export default __webpack_public_path__ + "images/1c71ed9c4a4af656fa1c73aefa38f69b-rafting_small.webp";